import { Cari } from './cari';
import { FaturaAciklama } from './fatura-aciklama';
import { FaturaGorsel } from './fatura-gorsel';
import { FaturaKalem } from './fatura-kalem';
import { FaturaOnaySeviye } from './fatura-onay-seviye';
import { Master } from './master';
import { Sube } from './sube';
import { Talep } from './talep';

export class Fatura {

  public static DURUM_RED = -1;
  public static DURUM_ONAY_SURECI = 0;
  public static DURUM_ONAYLI = 1;
  public static DURUM_NETSISE_AKTARILDI = 2;

  id: number;
  sube: Sube;
  subeId: number;
  durum: number;
  netsiseIslendi: boolean;
  faturaNo: string;
  faturaTipId: number;
  cari: Cari;
  cariId: number;
  tarih: Date;
  malHizmetCinsi: string;
  malHizmetMiktar: string;
  faturaSeriNo: string;
  aciklama: string;
  private pFaturaKalemler: FaturaKalem[];
  private pFaturaGorseller: FaturaGorsel[];
  faturaOnaySeviye: FaturaOnaySeviye;
  faturaOnaySeviyeId: number;
  faturaTipi: Master;
  faturaAciklamalar: FaturaAciklama[];
  kullaniciId: number;
  talep: Talep;
  toplamTutar : any;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);

    if (obj.sube != null) {
      this.sube = new Sube(obj.sube);
    }
  }

  public get faturaKalemler(): FaturaKalem[] {
    return this.pFaturaKalemler;
  }

  public set faturaKalemler(list: FaturaKalem[]) {
    if (list != null) {
      this.pFaturaKalemler = list.map(f => new FaturaKalem(f));
    }
  }

  public get faturaGorseller(): FaturaGorsel[] {
    return this.pFaturaGorseller;
  }

  public set faturaGorseller(list: FaturaGorsel[]) {
    if (list != null) {
      this.pFaturaGorseller = list.map(t => new FaturaGorsel(t));
    }
  }

  get durumText(): string {
    if (this.durum != null) {
      if(this.durum === Fatura.DURUM_ONAY_SURECI){
        return this.faturaOnaySeviye?.kullaniciGrup?.isim + ' Onayında';
      }
      return Fatura.getDurumText(this.durum);
    }
    return '';
  }

  public static getDurumText(durum: number): string {
    if (durum != null) {
      switch (durum) {
        case Fatura.DURUM_RED:
          return 'Reddedildi';
        case Fatura.DURUM_ONAYLI:
          return 'Onaylı';
        case Fatura.DURUM_NETSISE_AKTARILDI:
          return 'Netsise İşlendi';
      }
    }
    return '';
  }
}
